import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Acesso} from 'src/app/core/acesso';
import {ControlContainer, NgForm} from '@angular/forms';
import {ToastService} from 'src/app/services/toast/toast.service';
import {ObjetivoAtividade} from "../../../core/objetivo-atividade";
import {ObjetivoService} from "../../../services/objetivo/objetivo.service";

@Component({
    selector: 'formulario-meta-objetivo',
    templateUrl: './formulario-objetivo-atividade.component.html',
    styleUrls: ['./formulario-objetivo-atividade.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FormularioObjetivoAtividadeComponent implements OnInit {

    @Input() objetivosAtividade: ObjetivoAtividade[];
    @Input() objetivoAtividade: ObjetivoAtividade;
    @Input() index: number;
    @Input() perfilAcesso: Acesso;


    pinObjetivo = Math.random();

    constructor(private drc: ChangeDetectorRef,
                private toastService: ToastService,
                private objetivoService: ObjetivoService) {
    }

    ngOnInit(): void {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }

    deletar() {
        this.objetivosAtividade.splice(this.index, 1);
        this.toastService.showSucesso("Objetivo removido com sucesso.")
    }

    onValorChangeObjetivo(registro: any) {
        if (registro && registro.idObjetivo) {
            let indexOfObjetivo = this.objetivosAtividade.findIndex((objAtividade: ObjetivoAtividade) => objAtividade.objetivo?.idObjetivo === registro.idObjetivo);
            if (indexOfObjetivo === -1 || indexOfObjetivo === this.index) {
                this.objetivoService.getById(registro.idObjetivo).subscribe((objetivo: any) => {
                    this.objetivoAtividade.objetivo = objetivo;
                });
            } else {
                this.toastService.showAlerta("Objetivo já adicionado.")
                this.objetivosAtividade.splice(this.index, 1);
                this.objetivoAtividade = new ObjetivoAtividade();
                this.objetivosAtividade.splice(this.index, 0, this.objetivoAtividade);
            }
        }
    }
}

